/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum MobileOperatorEventSource {
    NPCK_AFC = 'NPCK_AFC',
    OPERATOR_FRAUD_SYSTEM = 'OPERATOR_FRAUD_SYSTEM',
    MANUAL_REVIEW = 'MANUAL_REVIEW',
    FRAUDULENT_ACTIVITY = 'FRAUDULENT_ACTIVITY',
    OTHER = 'OTHER'
}

